import _regenerator from "/root/project/msp-fronted/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/root/project/msp-fronted/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/root/project/msp-fronted/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import { ref, provide, reactive } from 'vue';
import enUS from 'ant-design-vue/es/locale/en_US';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { ConfigProvider } from 'ant-design-vue';
import { setTheme } from './styles/theme';
import { themes } from './styles/theme/themeData';
import instance from './api/axios';
import axios from './api/request.js';
export default {
  name: 'App',
  components: {},
  setup: function setup() {
    var haveConfig = ref(false);
    var ottApiUrl = reactive({
      local: 'http://localhost:9007',
      development: 'https://app-uat-api.ezways.net',
      sandbox: 'x',
      test2: 'x',
      uat: 'https://app-uat-api.ezways.net',
      production: 'https://app-api.ezways.net'
    });
    var handleApiUrl = function handleApiUrl(configUrl) {
      console.log('configUrl:', configUrl);
      var frontendUrl = window.location.origin;
      // if prod url, dynamic change according frontend url
      if (configUrl.includes('.ezways.net') && !frontendUrl.includes('local')) {
        console.log('frontend url:', frontendUrl);
        if (frontendUrl.includes('localhost')) {
          return configUrl;
        }
        // append "-api" to first subdomain
        // regexp extract first subdomain
        var subdomain = frontendUrl.match(/\/\/([a-z0-9-]+)\./)[1];
        var apiUrl = frontendUrl.replace(subdomain, "".concat(subdomain, "-api"));
        console.log('api url:', apiUrl);
        return apiUrl;

        // frontendUrl = frontendUrl.replace('//portal.', '//portal-api.')
        // const apiUrl = configUrl.replace('portal-api.ezways.net', frontendUrl.split('//')[1])
        // return apiUrl
      }
      return configUrl;
    };
    var projectData = ref({
      saasMerNameZh: 'Easyway',
      saasMerNameEn: 'Easyway',
      email: 'cs@ezways.net',
      website: '#',
      copyRight: '@Copyright 2026 Easyway. All rights reserved',
      address: '',
      themeKey: 'default',
      themeColor: 'rgb(87, 153, 196)',
      electronicReceipt: true,
      electronicReceiptBatch: true,
      openReceipt: true,
      supply: false,
      suffix: '',
      faviconList: 'fav.ico',
      darkLogoList: 'login-logo.png',
      lightLogoList: 'menu-logo.png',
      bgList: 'login-banner.png',
      apiUrl: handleApiUrl(ottApiUrl[process.env.NODE_ENV]),
      reconReceipt: true
    });
    provide('$themeData', projectData);
    var setFavicon = function setFavicon(url) {
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = url;
      document.getElementsByTagName('head')[0].appendChild(link);
    };
    var init = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var baseURL, _yield$instance$post, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(process.env.VUE_APP_SAASNAME !== 'MAIN')) {
                _context.n = 3;
                break;
              }
              baseURL = process.env.VUE_APP_SAAS_CONFIGURL;
              _context.n = 1;
              return instance.post("".concat(baseURL, "/saas/getSaasMerConfig"));
            case 1:
              _yield$instance$post = _context.v;
              data = _yield$instance$post.data;
              if (!(data.code === 'S00000')) {
                _context.n = 2;
                break;
              }
              projectData.value = _objectSpread({
                saasMerNameZh: data.data.saasMerNameZh,
                saasMerNameEn: data.data.saasMerNameEn,
                electronicReceiptBatch: false
              }, JSON.parse(data.data.frontJson));
              _context.n = 3;
              break;
            case 2:
              return _context.a(2, false);
            case 3:
              // setTheme(projectData.value.themeKey)
              setTheme(themes[process.env.VUE_APP_SAASNAME] ? process.env.VUE_APP_SAASNAME : 'default');
              setFavicon(projectData.value.faviconList);
              ConfigProvider.config({
                // theme: themes[projectData.value.themeKey] || themes[process.env.VUE_APP_SAASNAME] || themes['default']
                theme: themes[process.env.VUE_APP_SAASNAME] || themes['default']
              });
              axios.defaults.baseURL = projectData.value.apiUrl;
              haveConfig.value = true;
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function init() {
        return _ref.apply(this, arguments);
      };
    }();
    init();
    return {
      enUS: enUS,
      zhCN: zhCN,
      haveConfig: haveConfig
    };
  }
};